export enum TipoCarteira {
  Somente_Pessoas_Fisicas = 1,
  Somente_Pessoas_Juridicas = 2,
  Todos = 3
}
